import { ReactNode } from "react";

import LinkButton from "ds/components/Button/LinkButton";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

type NoWorkspaceErrorProps = {
  message: ReactNode;
};

// Connecting a workspace is admin-only, so admins get a direct link while everyone else is told to ask one.
const NoWorkspaceError = ({ message }: NoWorkspaceErrorProps) => {
  const { viewer } = useTypedContext(AccountContext);

  return (
    <>
      {message}{" "}
      {viewer.admin ? (
        <FeedbackActions>
          <LinkButton variant="contrast" size="small" to="/integrations/slack">
            Connect a Slack workspace
          </LinkButton>
        </FeedbackActions>
      ) : (
        "Ask an admin to connect one before linking your account."
      )}
    </>
  );
};

export default NoWorkspaceError;
